import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-sign-up',
    templateUrl: './sign-up.component.html'
})
export class SignUpComponent implements OnInit {
    isBrowser;

    constructor(
        @Inject(PLATFORM_ID) private platformId,
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            const config = environment.aadConfig;
            window.location.href = `${config.stsServer}authorize?p=${config.sign_up_policy}&client_id=${config.client_id}&nonce=defaultNonce&redirect_uri=${config.redirect_url}&scope=openid&response_type=id_token&prompt=login`;
        }
    }
}
